export const reduxStorage = {
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      return Promise.resolve();
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      return Promise.reject(error);
    }
  },
  getItem: (key) => {
    try {
      const value = localStorage.getItem(key);
      return Promise.resolve(value);
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return Promise.reject(error);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      return Promise.resolve();
    } catch (error) {
      console.error('Error removing from localStorage:', error);
      return Promise.reject(error);
    }
  },
};

export const clearStorage = async () => {
  try {
    localStorage.clear();
    console.log("All storage cleared successfully");
    return Promise.resolve();
  } catch (error) {
    console.error("Failed to clear storage:", error);
    return Promise.reject(error);
  }
};